import React from 'react';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { TableCell } from '@experiences/components/table/table-cell';
import { TableRow } from '@experiences/components/table/table-row';
import { UNPAID_INVOICES_TABLE_ROW_HEIGHT } from '@finance-hub/domain/invoicing/components/unpaid-invoices-table-columns';
import { UnpaidInvoiceRow } from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-list';

interface Props {
  row: Row<UnpaidInvoiceRow>;
}

export const UnpaidInvoicesTableRow = React.memo<Props>(({ row }) => {
  const [styles] = useStyles();

  return (
    <Pressable style={styles.row} tabIndex={-1}>
      {({ hovered }) => (
        <TableRow
          index={row.index}
          style={{ minHeight: UNPAID_INVOICES_TABLE_ROW_HEIGHT }}
        >
          {row
            .getVisibleCells()
            .map((cell: Cell<UnpaidInvoiceRow, unknown>) => (
              <TableCell
                cell={cell}
                key={cell.id}
                style={hovered ? styles.hovered : undefined}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            ))}
        </TableRow>
      )}
    </Pressable>
  );
});

UnpaidInvoicesTableRow.displayName = 'UnpaidInvoicesTableRow';

const useStyles = createStyles((theme) => ({
  hovered: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
  row: {
    cursor: 'auto',
  },
}));
